import * as React from 'react';
import { useTranslation } from 'next-i18next';

import { useLoginSignupPopup } from '../../../../hooks';

export type ConflictField = 'email' | 'phone_number';

/**
 * Support text for a first-step field whose value already belongs to an account: the reason,
 * then the way out.
 *
 * `field` decides which of the two the copy names. The wizard asks for an e-mail and a phone
 * number, the backend answers a conflict with the parameter it collided on, and telling someone
 * their e-mail is taken when it is their phone number leaves them with nothing to change.
 */
export const AlreadyUsedLoginHelperText: React.FunctionComponent<{ field: ConflictField }> = ({ field }) => {
  const { t } = useTranslation();
  const { onStartLogin } = useLoginSignupPopup();

  return (
    <span>
      {t(
        field === 'phone_number'
          ? 'onboarding-page:phone_number_already_used_do_this'
          : 'onboarding-page:email_already_used_do_this'
      )}{' '}
      <a
        className="underline"
        href="#!"
        onClick={(e) => {
          // Already in use: open the real login flow, never /signup
          // (that page only renders the lead-minting signup form).
          e.preventDefault();
          onStartLogin();
        }}
      >
        login
      </a>
    </span>
  );
};
